import { Flex } from '@chakra-ui/react';
import { TransactionStatusType } from '@halo/wallet-app';

export interface StatusTitleProps {
  status: TransactionStatusType;
}

const SuccessIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8.2147" cy="8.00084" r="6.42857" fill="#00B600" />
    <path
      d="M5.64258 8.00056L7.57115 9.92913L10.7854 6.71484"
      stroke="white"
      strokeWidth="1.28571"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PendingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
    <path
      d="M11 6.5C11 9.26142 8.76142 11.5 6 11.5C3.23858 11.5 1 9.26142 1 6.5C1 3.73858 3.23858 1.5 6 1.5C8.76142 1.5 11 3.73858 11 6.5Z"
      fill="#FF9D00"
    />
    <path d="M6 4V6.9H8" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const FailedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
    <circle cx="6" cy="6.5" r="5" fill="#FF3B3B" />
    <path d="M6 4.09961V6.49961" stroke="white" strokeLinecap="round" />
    <path
      d="M6.8399 8.53922C6.8399 9.00314 6.46382 9.37922 5.9999 9.37922C5.53598 9.37922 5.1599 9.00314 5.1599 8.53922C5.1599 8.0753 5.53598 7.69922 5.9999 7.69922C6.46382 7.69922 6.8399 8.0753 6.8399 8.53922Z"
      fill="white"
    />
  </svg>
);

export const TransactionStatusData = {
  [TransactionStatusType.Pending]: {
    color: 'yellow.100',
    bg: 'yellow.10',
    icon: <PendingIcon></PendingIcon>,
    text: 'Pending',
  },
  [TransactionStatusType.Success]: {
    color: 'green.100',
    bg: 'green.10',
    icon: <SuccessIcon></SuccessIcon>,
    text: 'Success',
  },

  [TransactionStatusType.Failed]: {
    color: 'red.100',
    bg: 'red.10',
    icon: <FailedIcon></FailedIcon>,
    text: 'Failed',
  },
};

export function StatusTitle({ status }: StatusTitleProps) {
  const curStatus = TransactionStatusData[status];
  return (
    <Flex alignItems="center" gap="1.5">
      <Flex
        alignItems="center"
        gap="0.5"
        color={curStatus.color}
        bg={curStatus.bg}
        px="0.5"
        borderRadius="sm"
        fontSize="xs"
      >
        {curStatus.icon}
        {curStatus.text}
      </Flex>
    </Flex>
  );
}
